module.exports = __webpack_public_path__ + "img/study.be5030ca.webp";